import { useTranslation } from 'react-i18next'
import { usePermissions } from '~/entities/viewer'
import { canShowObject } from '~/shared/lib/utils'

type Header = { label: string; to: string; parent?: string }

export const useHeader = (): Header[] => {
  const { t } = useTranslation()
  const { canInspectionsView, canSettingsView, canRepairOrdersView } =
    usePermissions()

  return [
    ...canShowObject(canInspectionsView, {
      label: t('inspections'),
      to: '/inspections',
    }),
    ...canShowObject(canRepairOrdersView, {
      label: t('repair orders'),
      to: '/repair-orders',
    }),
    ...canShowObject(canRepairOrdersView, {
      label: t('road accidents'),
      to: '/road-accidents',
    }),
    ...canShowObject(canRepairOrdersView, {
      label: t('counterparties'),
      to: '/counterparties',
    }),
    ...canShowObject(canSettingsView, {
      label: t('settings'),
      to: '/settings/employees',
      parent: '/settings',
    }),
  ]
}
